'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

require('blockadblock'); // Configura el adblocker


blockAdBlock.setOption({
  debug: false,
  checkOnLoad: false,
  resetOnEnd: true,
  loopMaxNumber: 30
});

function createHash(length) {
  var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  var text = '';
  length = length || 6;

  for (var i = 0; i < length; i++) {
    text += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return text;
}

var randomHash = createHash(8);
var url0 = 'https://adpass.atresmedia.com/' + randomHash + '/index/advertisement.js';
var url1 = 'https://adpass.atresmedia.com/' + randomHash + '/index/adjs.js';
var url2 = 'https://adpass.atresmedia.com/' + randomHash + '/index/' + randomHash + '/advertisement.js';
var url3 = 'https://adpass.atresmedia.com/' + randomHash + '/index/' + randomHash + '/adjs.js';
var url4 = 'https://adpass.atresmedia.com/' + randomHash + '/satelliteLib-' + randomHash + '.js';
var url5 = 'https://assets.adobedtm.com/' + randomHash + '/noadtry.txt';
var detected = undefined;

var getIsAdblock = function getIsAdblock() {
  return Promise.all([fetch(url0), fetch(url1), fetch(url2), fetch(url3), fetch(url4), fetch(url5, {
    mode: 'no-cors'
  })]).then(function (value) {
    return typeof value === 'undefined';
  }).catch(function (reason) {
    return true;
  });
};

exports.default = function () {
  if (typeof detected === 'undefined') {
    if (typeof window.blockAdBlock === 'undefined') {
      detected = true;
      return Promise.resolve(detected);
    } else {
      // Comprobar manualmente si AdBlock está habilitado.
      // Devuelve `true` al completar el cheque.
      // Devuelve `false` si no se puede realizar la verificación (por ejemplo, debido a otra verificación en curso).
      // El parámetro 'loop' permite verificar sin bucle varias veces según el valor de 'loopMaxNumber'
      // Ejemplo: loop = true => time ~ = 200ms (el tiempo varía según la configuración)
      //           loop = false => time ~ = 1 ms
      // # bucle: booleano (predeterminado: verdadero)
      window.blockAdBlock.check();
    }

    return new Promise(function (resolve, reject) {
      blockAdBlock.onDetected(function () {
        detected = true;
        resolve(detected);
      });
      blockAdBlock.onNotDetected(function () {
        getIsAdblock().then(resolve);
      });
    });
  }

  return Promise.resolve(detected);
};